<template>
  <div>
    <h2 class="col-lg-12 text-center mb-3">{{ $t('add') }}</h2>
    <StaticInfosForm @submit-requested="submitRequested"></StaticInfosForm>
  </div>
</template>
 
<script>
import { mapActions } from 'vuex'
import StaticInfosForm from './StaticInfosForm.vue'

  export default {
  components: { StaticInfosForm },
  methods: {
    ...mapActions('staticInfos', ['postStaticInfo']),
    submitRequested (input) {
      this.postStaticInfo(input);
    },
  }
}
</script> 
 
<style scoped>
thead > tr > th
{
  text-align: unset !important;
}
</style> 